import API_URL from '../config';
import axios from 'axios';

import { getCookie } from './../utils/cookies';

export const addNewFournisseurApi = async(fournisseurName) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const objectData = {
            Name: fournisseurName
        }

        const res = await axios.post(`${API_URL}/api/V2/fournisseur/addFournisseur/${id}/${iv}`, objectData, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const updateFournisseurApi = async(Name, fournisseurId) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const objectData = {
            Name: Name
        }

        const res = await axios.put(`${API_URL}/api/V2/fournisseur/updateFournisseur/${id}/${iv}/${fournisseurId}`, objectData, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const getAllFournisseursApi = async (Name = "") => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/fournisseur/getAllFournisseurs/${id}/${iv}?Name=${Name}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const deleteFournisseurApi = async(fournisseurId) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.delete(`${API_URL}/api/V2/fournisseur/deleteOneFournisseur/${id}/${iv}/${fournisseurId}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}
